// extracted by mini-css-extract-plugin
export default {"tooltip":"xp-z","sharingV2":"yp-z","sharingIconsV2":"zp-z","links":"Ap-z","link":"Bp-z","facebookV2":"Cp-z","twitterV2":"Dp-z","pinterestV2":"Ep-z"};